module.exports = __webpack_public_path__ + "static/media/hero_desktop.caa7ccd3.webp";